import React from 'react'
import { UserRole } from 'store/types/app-types'
import { CommonRoleRouteProps, RoleRoute } from '../RoleRoute'

const PlayerAndAdminRoles: UserRole[] = ['Player', 'StuffAdmin', 'SuperAdmin', 'Organizer']

export const AnyRoleRoute = (props: CommonRoleRouteProps) => {
  return (
    <RoleRoute
      {...props}
      roles={PlayerAndAdminRoles}
      defaultPath="/"
    />
  )
}
